<script lang="ts">
  import type { RecommendedProduct } from "../../../interfaces/RecommendationProduct"

  export let product: RecommendedProduct

  $: media = product?.media[0]
</script>

{#if media && (media.type === "image" || media.type === "image-set")}
  <div class="product-image">
    <!-- svelte-ignore a11y-missing-attribute -->
    <img {...(media.attributes)} class={$$props.class}/>
  </div>
{/if}

<style lang="scss">
  div {
    padding-top: 100%;
    position: relative;
  }
  
  img {
    position: absolute;
    top: 0;
    height: 100%;
    object-fit: contain;
  }
</style>